import { createSelector } from 'reselect'
import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'

const getLoyaltyRoomUpgradeBenefit = createSelector(
  (state: App.State) => getIsLoyaltyEnabled(state),
  (state: App.State) => state.loyalty.account.data?.benefits,
  (
    isLoyaltyEnabled,
    benefits,
  ): App.LoyaltyBenefit | undefined => {
    if (!isLoyaltyEnabled) return
    return benefits?.find(benefit => benefit.code === 'hotel_upgrade')
  },
)

export default getLoyaltyRoomUpgradeBenefit
